module.exports = __webpack_public_path__ + "img/mtf.f3ba1e85.jpg";